<template>
	<div>
		<div class="dds-notice">
			<div class="dds-notice-icon">
				<i class="iconimg iconimg-notice"></i>
			</div>
			<div class="dds-notice-time">
				<span>{{noticleList.view_time?noticleList.view_time.split('-')[0]:2021}}</span>
				<strong>{{noticleList.view_time?noticleList.view_time.split('-')[1]+'-'+noticleList.view_time.split('-').pop():'09-06'}}</strong>
			</div>
			<div class="dds-notice-text">
				<h5>
					<a>{{noticleList.article_title?noticleList.article_title: $namePc + '通知'}}</a>
				</h5>
				<p>
          <a v-if="noticleList.article_content" v-html="HTMLDecode(noticleList.article_content)"></a>
					<a v-else>{{noticle}}</a>
				</p>
			</div>
			<div class="dds-notice-more">
				<router-link :to="{path:'/aboutMe'}">
					<span>更多公告</span>
					<i class="icon-arrow-right iconfont"></i>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		props:{
			noticle:{
				type:String,
				default:""
			},
      noticleList:{
      	type:Object,
      	default:{}
      },
		},
    methods:{
      HTMLDecode(text) {
      	var temp = document.createElement("div");
      	temp.innerHTML = text;
      	var output = temp.innerText || temp.textContent;
      	temp = null;
      	return output;
      },
    }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/noticle/index.vue